import axios from 'axios';

export class DataLoader {
    static extract({entityType, method, text, numberOfTerms, numberOfConcepts, conceptMinimumScore}) {
        return axios.post('/extract', {
            entityType,
            method,
            // classifier,
            text,
            numberOfTerms,
            numberOfConcepts,
            conceptMinimumScore
        });
    }

    static projects(user, password) {
        return axios.post('/projects', {
            user: user,
            password: password
        });
    }
}